import {
    format as _format,
    startOfDay as _startOfDay,
    startOfToday as _startOfToday,
    getDay as _getDay,
    isToday as _isToday,
    parse as _parse,
    addHours as _addHours,
    addDays as _addDays,
    addWeeks as _addWeeks,
    subWeeks as _subWeeks,
    addMonths as _addMonths,
    subMonths as _subMonths,
    addYears as _addYears,
    subYears as _subYears,
    subDays as _subDays,
    setDay as _setDay,
    setHours as _setHours,
    setMinutes as _setMinutes,
    startOfWeek as _startOfWeek,
    startOfHour as _startOfHour,
    startOfMonth as _startOfMonth,
    endOfDay as _endOfDay,
    endOfWeek as _endOfWeek,
    endOfMonth as _endOfMonth,
    isTomorrow as _isTomorrow,
    isSameDay as _isSameDay,
    differenceInCalendarDays as _differenceInCalendarDays,
    max,
    min
} from 'date-fns';

// import _isEmpty from 'lodash/isEmpty';
// import _cloneDeep from 'lodash/cloneDeep';

// import memoize from 'fast-memoize';

import ruLocale from 'date-fns/locale/ru';
//
// import {
//     createNumbersArray
// } from '.';

const locale = ruLocale;

export const getDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) {
        return isNaN(date.getTime()) ? null : date;
    }

    // TODO обдумать: parse(date, 'yyyy-MM-dd') оказался надежней, см PL-2864
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed;
};

export const format = (date, formatString = 'dd.MM.yyyy', options = {}) => {
    const d = getDate(date);
    if (!d) return null;
    
    return _format(d, formatString, {
        ...options,
        locale
    });
};
export const formatDateTime = date => format(date, 'dd.MM.yyyy HH:mm:ss');

export const formatDateISO = date => format(date, 'yyyy-MM-dd');
export const formatDateTimeISO = date => format(date, "yyyy-MM-dd'T'HH:mm:ss");
export const parseDateISO = str => parse(str, 'yyyy-MM-dd');
export const parseDateTimeISO = str => parse(str, "yyyy-MM-dd'T'HH:mm:ss");

export const startOfHour = date => date && _startOfHour(getDate(date));

export const startOfDay = date => date && _startOfDay(getDate(date));
export const startOfToday = () => _startOfToday();
export const endOfDay = date => date && _endOfDay(getDate(date));

export const startOfWeek = (date, options) => date && _startOfWeek(getDate(date), {
    weekStartsOn: 1,
    ...options
});
export const endOfWeek = (date, options) => date && _endOfWeek(getDate(date), {
    weekStartsOn: 1,
    ...options
});

export const setDay = (date, day, options = {}) => {
    return date && _setDay(getDate(date), day, {
        weekStartsOn: 1,
        ...options
    });
};

export const getDay = date => date && _getDay(getDate(date));

export const setHours = (date, number) => date && _setHours(getDate(date), number);
export const setMinutes = (date, number) => date && _setMinutes(getDate(date), number);

export const isToday = (date) => date && _isToday(getDate(date));

export const addHours = (date, number) => date && _addHours(getDate(date), number);

export const addDays = (date, number) => date && _addDays(getDate(date), number);
export const subDays = (date, number) => date && _subDays(getDate(date), number);

export const isTomorrow = (date) => date && _isTomorrow(getDate(date));

export const addWeeks = (date, number) => date && _addWeeks(getDate(date), number);
export const subWeeks = (date, number) => date && _subWeeks(getDate(date), number);

export const addMonths = (date, number) => date && _addMonths(getDate(date), number);
export const subMonths = (date, number) => date && _subMonths(getDate(date), number);

export const addYears = (date, number) => date && _addYears(getDate(date), number);
export const subYears = (date, number) => date && _subYears(getDate(date), number);

export const startOfMonth = (date) => _startOfMonth(getDate(date));
export const endOfMonth = (date) => _endOfMonth(getDate(date));

export const startOfPrevMonth = (date) => subMonths(_startOfMonth(getDate(date)), 1);
export const endOfPrevMonth = (date) => endOfMonth(subMonths(_startOfMonth(getDate(date)), 1));

export const parse = (str, format, options = {}) => {
    return str && _parse(str, format, new Date(), {
        locale,
        ...options
    });
};

export const parseTimeWithDate = ({
    timeStr,
    format = 'HH:mm',
    date = new Date(),
    options = {}
}) => {
    return timeStr && _parse(timeStr, format, date, {
        locale,
        ...options
    });
};

//TODO check diff w 'formatDateISO' & usage & remove
export const getDateISOStr = date => _format(date, 'yyyy-MM-dd');

export const isBetween = (date, dateLeft, dateRight) => getDate(date) >= getDate(dateLeft) && getDate(date) <= getDate(dateRight);
export const isSameOrAfter = (dateLeft, dateRight) => getDate(dateLeft) >= getDate(dateRight);
export const isSameOrBefore = (dateLeft, dateRight) => getDate(dateLeft) <= getDate(dateRight);
export const isSameDayOrAfter = (dateLeft, dateRight) => +startOfDay(dateLeft) >= +startOfDay(dateRight);
export const isSameDayOrBefore = (dateLeft, dateRight) => +startOfDay(dateLeft) <= +startOfDay(dateRight);

export const isBefore = (dateLeft, dateRight) => getDate(dateLeft) < getDate(dateRight);
export const isAfter = (dateLeft, dateRight) => getDate(dateLeft) > getDate(dateRight);

export const getMaxDate = (...args) => {
    if (Array.isArray(args[0])) {
        return max(args.map(item => getDate(item)));
    }

    const dateLeft = args[0];
    const dateRight = args[1];

    return max([getDate(dateLeft), getDate(dateRight)]);
};
//
// export const getMaxValidDate = (dates) => {
//     if (_isEmpty(dates)) return null;
//
//     const filtered = dates.filter(date => !!checkDate(date));
//
//     if (_isEmpty(filtered)) return null;
//
//     return max(filtered);
// };
//
// export const getMinValidDate = (dates) => {
//     if (_isEmpty(dates)) return null;
//
//     const filtered = dates.filter(date => !!checkDate(date));
//
//     if (_isEmpty(filtered)) return null;
//
//     return min(filtered);
// };

export const getMinDate = dates => min(dates.map(item => getDate(item)));

export const getWeekNumber = (date) => {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date - firstDayOfYear) / 86400000;

    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

export const getDayName = date => _format(getDate(date), 'eeee', {
    locale
});

export const startOfNextHour = date => addHours(startOfHour(date), 1);

export const isSameDay = (dateLeft, dateRight) => _isSameDay(getDate(dateLeft), getDate(dateRight));

// export const getMonthNames = memoize((from, to) => {
//     return createNumbersArray(from, to).map(item => locale.localize.month(item));
// });

// Test before usage
// export const getDateFromWeekNumber = (year, weekNumber) => {
//     return startOfWeek(addWeeks(new Date(year, 0, 1), weekNumber - 1));
// };

// export const getDayRange = (dateFrom, dateTo, formatStr = 'EEEE, dd') => {
//     const days = [];
//
//     let day = _cloneDeep(dateFrom);
//
//     while (!isAfter(day, dateTo)) {
//         days.push({
//             name: format(day, formatStr),
//             isToday: isToday(day)
//         });
//
//         day = addDays(day, 1);
//     }
//
//     return days;
// };

/**
 * Возвращает следующий рабочий день (пропускает выходные Сб/Вс и указанные нерабочие дни)
 * @param {Date} fromDate - Дата, от которой считать (по умолчанию сегодня)
 * @param {Array} holidays - Массив дат-праздников (строки или Date объекты)
 * @returns {Date} Следующий рабочий день
 */
export const getNextBusinessDay = (fromDate = new Date(), holidays = []) => {
    let nextDay = _addDays(_startOfDay(fromDate), 1);
    const holidayTimestamps = holidays.map(h => {
        const d = h instanceof Date ? h : new Date(h);
        return _startOfDay(d).getTime();
    });
    
    // Пропускаем выходные (Сб=6, Вс=0) и праздники
    while (
        nextDay.getDay() === 0 || 
        nextDay.getDay() === 6 || 
        holidayTimestamps.includes(nextDay.getTime())
    ) {
        nextDay = _addDays(nextDay, 1);
    }
    return nextDay;
};

/**
 * Возвращает текущий день, если он рабочий, иначе ближайший следующий рабочий день
 * @param {Date} fromDate - Дата, от которой считать (по умолчанию сегодня)
 * @param {Array} holidays - Массив дат-праздников (строки или Date объекты)
 * @returns {Date} Текущий или ближайший рабочий день
 */
export const getCurrentOrNextBusinessDay = (fromDate = new Date(), holidays = []) => {
    let day = _startOfDay(fromDate);
    const holidayTimestamps = holidays.map(h => {
        const d = h instanceof Date ? h : new Date(h);
        return _startOfDay(d).getTime();
    });
    
    // Если текущий день — выходной или праздник, берём следующий рабочий день
    while (
        day.getDay() === 0 || 
        day.getDay() === 6 || 
        holidayTimestamps.includes(day.getTime())
    ) {
        day = _addDays(day, 1);
    }
    return day;
};

export const dateIsValid = (str) => {
    try {
        const date = new Date(str);

        return !isNaN(date.getTime());
    } catch (e) {
        return false;
    }
};

export const checkDateObject = d => d instanceof Date && !isNaN(d);

export const getDayNames = () => ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];

export const getShortDayNames = () => ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const getShortDaysOptions = () => getShortDayNames().map((text, index) => ({
    key: index,
    text,
    value: index
}));

export const getDaysOptions = () => getDayNames().map((text, index) => ({
    key: index,
    text,
    value: index
}));

export const getPrevMonthName = () => {
    const date = new Date();
    const month = date.getMonth();

    if (month === 0) return getMonthNameIn(11);

    return getMonthNameIn(month - 1);
};

export const getMonthNameIn = (num) => {
    const arr = ['январе', 'феврале', 'марте', 'апреле', 'мае', 'июне', 'июле', 'августе', 'сентябре', 'октябре', 'ноябре', 'декабре'];

    return arr[num];
};

export const getMonthNameOf = (num) => {
    const arr = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

    return arr[num];
};

// export const getMonthName = (d) => {
//     const date = getDate(d);
//
//     if (!dateIsValid(date)) return '';
//
//     const month = date.getMonth();
//     const monthNames = getMonthNames(0, 11);
//
//     return monthNames[month];
// };

export const joinDateTimeAndCreateISO = (date, time, dateFormat = 'dd.MM.yy') => {
    if (!(date && (date instanceof Date || typeof date === 'string'))) return null;

    const dateIsString = typeof date === 'string';

    const year = dateIsString
        ? date.slice(6, dateFormat === 'dd.MM.yy' ? 8 : 10)
        : date.getFullYear();

    const month = dateIsString
        ? date.slice(3, 5)
        : String(date.getMonth() + 1).padStart(2, 0);

    const day = dateIsString
        ? date.slice(0, 2)
        : String(date.getDate()).padStart(2, 0);

    const hour = time ? time.slice(0, 2) : '00';
    const minutes = time ? time.slice(3, 5) : '00';

    return `${year}-${month}-${day}T${hour}:${minutes}:00`;
};

export const splitDateTime = (date) => ({
    date: format(date, 'dd.MM.yy'),
    time: format(date, 'HH:mm')
});

export const getDateTimeByOffset = (date, offset, timeStr) => {
    const d = addDays(startOfDay(date), offset);

    return new Date(`${format(d, 'yyyy-MM-dd')}T${timeStr}`);
};

export const differenceInCalendarDays = (dateLeft, dateRight) => _differenceInCalendarDays(getDate(dateLeft), getDate(dateRight));

export const getDayWord = (daysCount = 0) => {
    const lastDigit = +(String(daysCount || 0).substr(-1));

    switch (true) {
        case (daysCount >= 5 && daysCount <= 20):
        case (lastDigit >= 5 && lastDigit <= 9):
        case (lastDigit === 0):
            return 'дней';

        case (lastDigit >= 2 && lastDigit <= 4):
            return 'дня';

        case (lastDigit === 1):
            return 'день';

        default:
            return 'дней';
    }
};

export const checkTime = (value) =>
    !!value && /^([01][0-9]|2[0-3]):([0-5][0-9])$/.test(value);

export const checkDate = date => date && date instanceof Date && !isNaN(date.getHours());

export const parseTimeString = str => parse(str, 'HH:mm');

export const timeIsAfter = (a, b) => {
    if (!(checkTime(a) && checkTime(b))) return false;

    return parseTimeString(a) > parseTimeString(b);
};

export const timeIsAfterNow = (time) => {
    if (!checkTime(time)) return false;

    return parseTimeString(time) > new Date();
};

export const timeIsBeforeNow = (time) => {
    if (!checkTime(time)) return false;

    return parseTimeString(time) < new Date();
};

export const datesAreEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const getDateRegex = (format = 'dd.MM.yyyy') => {
    switch (format) {
        case 'dd.MM.yy':
            return /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.]\d\d/g;

        case 'dd.MM.yyyy':
        default:
            return /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/g;
    }
};

export const convertDateToString = (date) => {
    if (!checkDateObject(date)) {
        return;
    }
    return `${date.getDate().toString().padStart(2, '0')} ${getMonthNameOf(date.getMonth())} ${date.getFullYear()}`;
};



// WEBPACK FOOTER //
// ./App/services/dateUtils.js